// Turns decimal number into 'XXXX-XXXX' where X - is hexadecimal.
export default function IdToHrHex(Uid) {
  if (Uid !== null) {
    Uid = Uid.toString(16).toUpperCase().padStart(8, 0);
    Uid = `${Uid.slice(0, 4)}-${Uid.slice(4, 8)}`;
    return Uid;
  }
  return null;
}
